module.exports = __webpack_public_path__ + "fdfb6073a1f406e523de84c0bc796131.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/font_uzv8nkw1nabgldi.svg
// module id = 1819
// module chunks = 0